import {
  useCustomerQuery,
  useCustomerSession,
  UseCustomerSessionReturn,
} from '@graphcommerce/magento-customer/hooks'
import { Trans } from '@lingui/react'
import { NoSsr } from '@mui/material'
import Link from 'next/link'
import { AccountOrderItemsDocument } from './AccountOrderItems.gql'

type OrdersFabContentProps = {
  session?: UseCustomerSessionReturn
}

function OrdersFabContent(props: OrdersFabContentProps) {
  const { session } = props

  const orders = useCustomerQuery(AccountOrderItemsDocument, {
    fetchPolicy: 'cache-and-network',
    variables: {
      pageSize: 5000,
      currentPage: 1,
    },
  })

  const activeOrderCount =
    orders.data?.customer?.orders?.items?.filter(
      (item) =>
        item?.status?.toUpperCase() !== 'CANCELED' &&
        item?.status?.toUpperCase() !== 'ORDER SHIPPED' &&
        item?.status?.toUpperCase() !== 'COMPLETE',
    )?.length ?? 0

  if (session?.loggedIn) {
    return (
      <div className='relative'>
        <Link href='/account'>
          <div className='group flex h-[35px] min-w-[121px] items-center justify-center gap-x-[12px] rounded-[20px] border-[1px] border-bright-templi-purple bg-pure-white px-5 pl-[8px] pr-0 hover:bg-bright-templi-purple'>
            <p className='Type-Large-Medium text-black group-hover:text-pure-white'>
              <Trans id='My Orders' />
            </p>
            {activeOrderCount > 0 && (
              <div className='flex h-[25px] w-[25px] items-center justify-center rounded-[50%] bg-material-ui-blue group-hover:bg-material-ui-dark-blue '>
                <span className='group text-center text-[12px] font-bold text-pure-white '>
                  {activeOrderCount}
                </span>
              </div>
            )}
            {/* <div className='absolute top-0 flex h-full w-full items-center justify-center' /> */}
          </div>
        </Link>
      </div>
    )
  }

  return null
}

export type OrdersFabProps = Omit<OrdersFabContentProps, 'session'>

export function OrdersFab(props: OrdersFabProps) {
  const session = useCustomerSession()

  return (
    <NoSsr fallback={<OrdersFabContent {...props} />}>
      <OrdersFabContent session={session} {...props} />
    </NoSsr>
  )
}
